export enum PriceVariant {
  DEFAULT = 'default',
  PSU = 'psu'
}
